<button
  type="button"
  class="background-tool"
  (click)="tooltip = !tooltip"
  [disabled]="isOffline || isZoomed"
  [class.cursorDefault]="isOffline || isZoomed"
>
  <txtb-icons
    type="bg"
    [fill]="isOffline || isZoomed ? disabledColor : tooltip ? activeColor : null"
  ></txtb-icons>
</button>
<ul class="tooltip" *ngIf="tooltip && !isOffline && !isZoomed">
  <li
    class="background-option elementary-lines"
    (click)="sendStyles(backgroundStyles.ElementarySchoolLines)"
  >
    <txtb-icons
      type="bgElementarySchoolLines"
      [stroke]="pickedBackground === backgroundStyles.ElementarySchoolLines ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="background-option lines" (click)="sendStyles(backgroundStyles.Lines)">
    <txtb-icons
      type="bgLines"
      [stroke]="pickedBackground === backgroundStyles.Lines ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="background-option grid" (click)="sendStyles(backgroundStyles.Grid)">
    <txtb-icons
      type="bgGrid"
      [stroke]="pickedBackground === backgroundStyles.Grid ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="background-option axis" (click)="sendStyles(backgroundStyles.Axis)">
    <txtb-icons
      type="bgAxis"
      [fill]="pickedBackground === backgroundStyles.Axis ? activeColor : null"
      [stroke]="pickedBackground === backgroundStyles.Axis ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="background-option white" (click)="sendStyles(backgroundStyles.White)">
    <txtb-icons
      type="bgWhite"
      [stroke]="pickedBackground === backgroundStyles.White ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="background-option gray" (click)="sendStyles(backgroundStyles.Gray)">
    <txtb-icons
      type="bgGray"
      [stroke]="pickedBackground === backgroundStyles.Gray ? activeColor : null"
    ></txtb-icons>
  </li>
</ul>
